import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      const token = localStorage.getItem('token');
      const userData = localStorage.getItem('userData');

      // Se não tem token ou userData, limpar e sair
      if (!token || !userData) {
        localStorage.removeItem('token');
        localStorage.removeItem('userData');
        setUser(null);
        setLoading(false);
        return;
      }

      // Validar token no backend se necessário
      try {
        const parsed = JSON.parse(userData);
        
        // Verificar se token não é string inválida
        if (token === 'undefined' || token === 'null' || token.trim().length === 0) {
          console.warn('Token inválido encontrado, limpando...');
          localStorage.removeItem('token');
          localStorage.removeItem('userData');
          setUser(null);
          setLoading(false);
          return;
        }

        // Se userData tem token, usar ele; senão usar do localStorage
        const finalToken = parsed.token || token;
        setUser({ ...parsed, token: finalToken });
        
        // Sincronizar localStorage
        if (!parsed.token) {
          localStorage.setItem('userData', JSON.stringify({ ...parsed, token: finalToken }));
        }
      } catch (err) {
        console.error('Erro ao parsear userData:', err);
        localStorage.removeItem('userData');
        localStorage.removeItem('token');
        setUser(null);
      }
      
      setLoading(false);
    };

    loadUser();
  }, []);

  const login = (userData, token) => {
    if (!token) return console.error('Token inválido no login');

    const userWithToken = { ...userData, token };
    setUser(userWithToken);
    localStorage.setItem('userData', JSON.stringify(userWithToken));
    localStorage.setItem('token', token);
  };

  const logout = () => {
    console.log('🚪 Fazendo logout...');
    
    // Limpar estado
    setUser(null);
    
    // Limpar TODO o localStorage relacionado
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    localStorage.removeItem('walletInfo');
    localStorage.removeItem('walletAddress');
    localStorage.removeItem('x_access_token');
    
    // Limpar sessionStorage também (caso tenha algo)
    sessionStorage.clear();
    
    console.log('✅ Logout completo, redirecionando...');
    
    // Redirecionar para home
    window.location.href = '/';
  };

  const updateProfile = async (updatedData) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const API_URL = process.env.REACT_APP_API_URL || 'https://plexo-natural-api.onrender.com';

      const res = await fetch(`${API_URL}/profile`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(updatedData)
      });

      const result = await res.json();
      if (!res.ok) throw new Error(result.error || 'Erro ao atualizar');

      const updatedUser = { ...result.profile, token };
      setUser(updatedUser);
      localStorage.setItem('userData', JSON.stringify(updatedUser));
      setLoading(false);
      return { success: true, profile: updatedUser };
    } catch (error) {
      setLoading(false);
      return { success: false, error: error.message };
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, updateProfile, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
